import { render, staticRenderFns } from "./ParticipantsEdit.vue?vue&type=template&id=5b0d2b26&"
import script from "./ParticipantsEdit.vue?vue&type=script&lang=js&"
export * from "./ParticipantsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports